import logoFull from '../../assets/logo/logo-full.svg';
import logoIcon from '../../assets/logo/logo-icon.svg';

export const TajerLogoFull = ({ height = 40, className = '' }) => (
  <img
    src={logoFull}
    alt="Tajer Pro"
    height={height}
    className={`${className} dark:brightness-0 dark:invert`.trim()}
    style={{ width: 'auto', height }}
  />
);

export const TajerLogoIcon = ({ size = 32, className = '' }) => (
  <img
    src={logoIcon}
    alt="Tajer Pro"
    width={size}
    height={size}
    className={`${className} dark:brightness-0 dark:invert`.trim()}
    style={{ width: size, height: size }}
  />
);

export default TajerLogoFull;
